import "./login.scss";

const LoginScreen = () => {
  return <div>Login</div>;
};

export default LoginScreen;
